import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import { DownloadIcon } from '../../theme/AthenaIcons';
import PermissionChecker, { permissionType } from '../permissions/PermissionChecker';
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import {action, observable} from "mobx";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import {observer} from "mobx-react";
import Version from "../../api/Version";

@observer
class DownloadButton extends React.Component {
  static propTypes = {
    href: PropTypes.string.isRequired,
    permission: permissionType,
    isAPOProdPlan: PropTypes.bool
  };
  static defaultProps = {
    permission: true,
    isAPOProdPlan: false
  };
  @observable anchorEl = null;

  @action handleOpen = event => this.anchorEl = event.currentTarget;

  @action close = () => this.anchorEl = null;

  @action downloadEuFormatCSV = async (versionId, fileName) => {
    const resp = await Version.ajaxRequest('get', `/${versionId}/version_download/?export=eu`);
    const url = window.URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  }
  open = () => Boolean(this.anchorEl)

  renderNode = (hasPermission, isAPOProdPlan, href) => {
    if (isAPOProdPlan) return (
      <IconButton
        component="a"
        onClick={(event) => this.handleOpen(event)}
        disabled={!hasPermission}
      >
        <DownloadIcon />
      </IconButton>
    )
    return (
      <Tooltip title="Download">
        <IconButton
          component="a"
          href={hasPermission ? href : '#'}
          disabled={!hasPermission}
        >
          <DownloadIcon />
        </IconButton>
      </Tooltip>
    )
  }

  render() {
    const { permission, href, isAPOProdPlan, versionId } = this.props;
    const anchorOpen = this.anchorEl;

    return (
      <PermissionChecker permission={permission}>
        {
          hasPermission =>
            <>
              <Tooltip title={'Download'}>
                {this.renderNode(hasPermission, isAPOProdPlan, href)}
              </Tooltip>
              <Popover
                open={this.open()}
                anchorEl={anchorOpen}
                onClose={() => this.close()}
                anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                transformOrigin={{vertical: 'top', horizontal: 'right'}}
              >
                <List disablePadding>
                    <ListItem
                      key={'Standard'}
                      button
                      onClick={() => this.close()}
                      component='a'
                      href={href}
                    >
                      <ListItemText primary={'STANDARD'} href={href} />
                    </ListItem>
                  <ListItem
                      key={'European'}
                      button
                      onClick={() => this.close()}
                      component='a'
                    >
                      <ListItemText primary={'EUROPEAN'}  onClick={() => this.downloadEuFormatCSV(versionId, href.split('/').pop())} />
                    </ListItem>
                </List>
              </Popover>
            </>
        }
      </PermissionChecker>
    );
  }
}

export default DownloadButton;
